import { PublicClientApplication } from "@azure/msal-browser";
import { MsalProvider } from "@azure/msal-react";
import * as Sentry from "@sentry/react";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min";
import ReactDOM from "react-dom/client";
import App from "./App";
import "./index.scss";
import reportWebVitals from "./reportWebVitals";
import { msalConfig } from "./utils/AzureAuthConfig";
import { AppConfig } from "./AppConfig";

// Ensure Web Crypto API is present in non-secure HTTP contexts (e.g., accessing via LAN IP)
if (typeof window !== "undefined") {
  if (!window.crypto) {
    (window as any).crypto = (window as any).msCrypto || {};
  }
  if (!window.crypto.getRandomValues) {
    window.crypto.getRandomValues = function <T extends ArrayBufferView | null>(array: T): T {
      if (array) {
        const uint8 = new Uint8Array(array.buffer, array.byteOffset, array.byteLength);
        for (let i = 0; i < uint8.length; i++) {
          uint8[i] = Math.floor(Math.random() * 256);
        }
      }
      return array;
    };
  }
  if (!window.crypto.subtle) {
    (window.crypto as any).subtle = {
      digest: () => Promise.resolve(new Uint8Array(32).buffer),
      importKey: () => Promise.resolve({}),
      exportKey: () => Promise.resolve(new Uint8Array(32).buffer),
      generateKey: () => Promise.resolve({}),
      sign: () => Promise.resolve(new Uint8Array(32).buffer),
      verify: () => Promise.resolve(true),
    };
  }
}

let msalInstance: PublicClientApplication;
try {
  msalInstance = new PublicClientApplication(msalConfig);
} catch (error) {
  console.warn("MSAL initialization notice:", error);
  msalInstance = new PublicClientApplication({
    ...msalConfig,
    auth: { ...msalConfig.auth, clientId: msalConfig.auth.clientId || "dummy" },
  });
}

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement,
);

Sentry.init({
  dsn: AppConfig.SENTRY_DSN,
  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.replayIntegration(),
  ],
  // Tracing
  tracesSampleRate: 1.0, //  Capture 100% of the transactions
  // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
  tracePropagationTargets: ["localhost:3000", /^https:\/\/yourserver\.io\/api/],
  // Session Replay
  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 1.0,
});

root.render(
  <>
    <MsalProvider instance={msalInstance}>
      <App />
    </MsalProvider>
  </>,
);
reportWebVitals();
